const API_BASE_URL = 'https://be.imfar.id';

export const API = {
  postTypes: {
    fetchAll: `${API_BASE_URL}/post-type`,
    fetchById: (id) => `${API_BASE_URL}/post-type/${id}`,
    create: `${API_BASE_URL}/post-type`,
    update: (id) => `${API_BASE_URL}/post-type/${id}`,
    delete: (id) => `${API_BASE_URL}/post-type/${id}`,
  },
  posts: {
    fetchAll: (page = 1, limit = 9) => `${API_BASE_URL}/post?page=${page}&limit=${limit}`,
    fetchFeatured: (limit = 6) => `${API_BASE_URL}/post?limit=${limit}`,
    fetchById: (id) => `${API_BASE_URL}/post/${id}`,
    create: `${API_BASE_URL}/post`,
    update: `${API_BASE_URL}/post`,
    delete: (id) => `${API_BASE_URL}/post/${id}`,
  },
  auth: {
    login: `${API_BASE_URL}/user/login`,
    register: `${API_BASE_URL}/user/register`,
  },
  user: {
    profile: `${API_BASE_URL}/user/profile`,
  }
};

export default API;
